module.exports = __webpack_public_path__ + "static/img/w3-1.495cb44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-1.png
// module id = 57b3
// module chunks = 1